import type { OrchestrationEvent, ThreadProviderRateLimitStatus } from "@cmmd-forge/contracts";

type RateLimitSetPayload = Extract<
  OrchestrationEvent,
  { type: "thread.rate-limit-set" }
>["payload"];

export type ThreadRateLimitEntry = ThreadProviderRateLimitStatus;

/**
 * FOR-32770: telemetry is scoped to the account that reported it, not the
 * provider. Keying by provider alone re-attributed account A's rejection to
 * account B the moment the user switched. Entries with a null account
 * (pre-dating the field) stay distinct from stamped ones.
 */
export function mergeThreadRateLimitStatus(
  prior: readonly ThreadRateLimitEntry[],
  payload: RateLimitSetPayload,
): ThreadRateLimitEntry[] {
  const eventAccountId = payload.providerAccountId ?? null;
  const sameScope = (entry: ThreadRateLimitEntry) =>
    entry.provider === payload.provider && (entry.providerAccountId ?? null) === eventAccountId;
  const existing = prior.find(sameScope);
  const window = {
    status: payload.status,
    usedPercent: payload.usedPercent,
    resetsAt: payload.resetsAt,
  };
  const nextEntry: ThreadRateLimitEntry = {
    provider: payload.provider,
    providerAccountId: eventAccountId,
    fiveHour: payload.window === "five_hour" ? window : (existing?.fiveHour ?? null),
    sevenDay: payload.window === "seven_day" ? window : (existing?.sevenDay ?? null),
  };
  return [...prior.filter((entry) => !sameScope(entry)), nextEntry];
}
